import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Text } from '../text';
export var SliderMark = function (_a) {
    var value = _a.value, label = _a.label, active = _a.active, labelClassName = _a.labelClassName;
    return (_jsxs("div", { className: 'absolute', style: { left: "".concat(value, "%") }, children: [_jsx("div", { className: "w-1 h-1 rounded-full ".concat(active ? 'bg-vjwPrimary' : 'bg-gray-400') }), label && (_jsx(Text, { variant: 'description', className: "text-nowrap ".concat(labelClassName), children: label }))] }));
};
